import VueRouter from "vue-router";
import Vue from "vue";
import routes from "./routes";
Vue.use(VueRouter);
// 先把VueRouter.prototype身上的push|replace方法进行保存一份
const originPush = VueRouter.prototype.push;
const originReplace = VueRouter.prototype.replace;
// 重写VueRouter.prototype身上的push方法了
VueRouter.prototype.push = function(location, resolve, reject) {
  // location：路由跳转的配置对象（query|params）
  if (resolve && reject) {
    // originPush：利用call修改上下文，变为(路由组件.$router)这个对象
    originPush.call(this, location, resolve, reject);
  } else {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};
// 重写VueRouter.prototype身上的replace方法
VueRouter.prototype.replace = function(location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject);
  } else {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回的这个y=0，代表的滚动条在最上方
    return { y: 0 };
  },
});

// 全局守卫：前置守卫（在路由跳转之间进行判断）
router.beforeEach(async(to, from, next) => {
  // to:获取到要跳转到的路由信息
  // from：获取到从哪个路由跳转过来来的信息
  // next: next() 放行  next(path) 放行

  // 移动端
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    if (to.path.includes('/m/')) {
      next();
    } else {
      next('/m' + to.fullPath);
    }
  } else {
    if (to.path.includes('/m/')) {
      next('/' + to.fullPath.slice(3));
    } else {
      next();
    }
  }
});

export default router;
